import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-myemail",
  "use": "icon-myemail-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\" id=\"icon-myemail\"><path d=\"M19.286.139H.714A.714.714 0 0 0 0 .853V15.14c0 .395.32.714.714.714h18.572c.395 0 .714-.32.714-.714V.853a.714.714 0 0 0-.714-.714zm-.893 2.473v11.634H1.607V2.612l-.616-.48.877-1.127.956.743h14.355l.955-.743.877 1.127-.618.48zm-1.214-.866L10 7.326l-7.179-5.58-.955-.743L.99 2.13l.616.48L9.23 8.538a1.25 1.25 0 0 0 1.533 0l7.63-5.926.616-.48-.877-1.127-.953.74z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol